module.exports = __webpack_public_path__ + "static/media/Tableau.141b7253.png";